// cookie-consent.service.impl.ts
import { inject, Injectable, signal } from '@angular/core';
import { CookieConsentService, CookieConsentPreferences } from './cookie-consent.service';
import { CookieService } from './cookie.service';
import { COOKIE_CONSENT_COOKIE_NAME, COOKIE_CONSENT_PREFS_STORAGE_KEY } from './cookie-constants';

@Injectable({ providedIn: 'root' })
export class CookieConsentServiceImpl extends CookieConsentService {
  private cookieService = inject(CookieService);

  preferences = signal<CookieConsentPreferences>(this.loadFromStorage());

  savePreferences(prefs: CookieConsentPreferences): void {
    localStorage.setItem(COOKIE_CONSENT_PREFS_STORAGE_KEY, JSON.stringify(prefs));
    this.preferences.set(prefs);
    const now = new Date().toISOString();
    const consent = prefs.analytics || prefs.advertising
      ? {accepted: true, acceptedAt: now}
      : {accepted: false, rejectedAt: now};
    this.cookieService.set(COOKIE_CONSENT_COOKIE_NAME, consent, 365);
  }

  private loadFromStorage(): CookieConsentPreferences {
    try {
      const stored = localStorage.getItem(COOKIE_CONSENT_PREFS_STORAGE_KEY);
      if (stored) return JSON.parse(stored) as CookieConsentPreferences;
    } catch {
      // corrupted storage — fall through to the consent cookie
    }

    // The banner's "Accept all" used to set only the consent cookie, so honour it for those users.
    // Anyone else has not opted in: optional cookies stay off until they do.
    const accepted = this.cookieService.get<{ accepted?: boolean }>(COOKIE_CONSENT_COOKIE_NAME)?.accepted === true;
    return { advertising: accepted, analytics: accepted };
  }
}
